import type { AuthCapabilities } from '../constants';

/**
 * Decide whether the login screen should skip the interstitial and
 * immediately start the single-sign-on flow.
 *
 * Auto-start happens only when BOTH hold:
 *
 *   1. SSO is the sole interactive sign-in method — `oidc` is enabled
 *      and neither `password` nor `magic_link` is. With two or more
 *      methods the interstitial is the method chooser and must stay.
 *
 *   2. The visit carries no `reason` query param. A `reason` means the
 *      user was *sent* here to read something — `logged_out` after
 *      sign-out, `missing_token` after an expired session, or an OIDC
 *      error code. Auto-redirecting those visits would either hide the
 *      message, instantly re-login a user who just signed out, or
 *      (for error reasons) spin a redirect loop against a failing IdP.
 *      Those visits keep the banner plus an explicit continue button,
 *      so the signed-out state is visible and stable.
 */
export function shouldAutoStartSso(caps: AuthCapabilities, reason: string): boolean {
  const soleSsoMethod = caps.oidc && !caps.password && !caps.magic_link;
  return soleSsoMethod && reason === '';
}
